import { useContext } from 'react';
import { useUsers } from '../api/users.api';
import SignInContext from '../contexts/SignInContext.context';
import { TUser } from '../types/users.types';
import { StatusLabel } from '@shared/components';
import { mergeClasses, Text, TextProps, Tooltip } from '@fluentui/react-components';
import Avatar, { TAvatarProps } from './Avatar';

type TProps = {
  id?: string | null;
  selfLabel?: string;
  avatarProps?: TAvatarProps;
  textProps?: TextProps;
  className?: string;
};

const renderUser = (
  users: TUser[],
  id: string,
  currentUser: TUser,
  selfLabel: string | undefined = undefined,
  avatarProps?: TAvatarProps,
  textProps?: TextProps,
  className?: string
) => {
  const foundUser = users.find((user) => user._id === id);
  if (!foundUser)
    return textProps ? (
      <Text {...textProps} className={avatarProps ? '' : className}>
        Unknown user
      </Text>
    ) : (
      <span className={avatarProps ? '' : className}>Unknown user</span>
    );

  const label =
    currentUser._id === id ? selfLabel || currentUser.name || 'Unknown user' : foundUser.name || 'Unknown user';
  const userLabel = (
    <Tooltip withArrow relationship="description" content={foundUser.mail}>
      {textProps ? (
        <Text {...textProps} className={avatarProps ? '' : className}>
          {label}
        </Text>
      ) : (
        <span className={avatarProps ? '' : className}>{label}</span>
      )}
    </Tooltip>
  );

  if (!avatarProps) return userLabel;

  return (
    <div className={mergeClasses('flex items-center space-x-1.5', className)}>
      <Avatar user={foundUser} size={28} tooltip="mail" {...avatarProps} />
      {userLabel}
    </div>
  );
};

const UserLabel = ({ id, selfLabel, avatarProps, textProps, className = '' }: TProps) => {
  const { users, error } = useUsers();
  const { user } = useContext(SignInContext);

  if (!id) return null;

  return (
    <StatusLabel
      data={users}
      loadingMessage=" "
      error={error}
      errorMessage="Error"
      plain
      render={(users) => renderUser(users, id, user, selfLabel, avatarProps, textProps, className)}
    />
  );
};

export default UserLabel;
